import React = require("react");
import { Align, cJSonFunctionLoadPreviewData, UpdateControl, UpdateFilePreview, UpdateImage } from "../common/communication.base";
import { K2ComponentState, WithContextPlacementProps, withContext, AcquireControl, StyleHelper } from "./k2hoc";
import { NclFilePreview } from "../common/components.ncl";
import { K2RuleWithVCXProps } from "./k2StyleRenderer";
import { getDenyImage, K2Img } from "./K2Image";
import { K2TruncateText } from "./K2TruncateText";
import { CancelablePromise, isPDF, isUrl, Log, makeCancelable } from "../common/common";
import { MediaData, MediaManager } from "../common/mediaManager";

class _FilePreview extends React.PureComponent<WithContextPlacementProps, K2ComponentState<UpdateFilePreview>> {
  static displayName = `K2FilePreview`;
  private control: NclFilePreview;
  private timer?: any;

  constructor(props: WithContextPlacementProps) {
    super(props);
    this.control = AcquireControl(this.props.controlUID, this.props.vrUID, (ctrl) => {
      return ctrl instanceof NclFilePreview;
    }) as NclFilePreview;
    this.state = { data: this.control.init(this) as UpdateFilePreview, vcxVersion: -1 };
  }

  updateState(state: UpdateControl) {
    this.setState((prevState: K2ComponentState<UpdateFilePreview>) => {
      return { data: state as UpdateFilePreview };
    });
  }

  updateVCX(vcxVersion: number) {
    this.setState({ vcxVersion: vcxVersion });
  }

  componentWillUnmount() {
    this.control.willUnMount(true);
    this.control = null;
  }

  componentDidUpdate(prevProps: WithContextPlacementProps, prevState: K2ComponentState<UpdateFilePreview>) {
    if (this.state.data.IsSupported && this.state.data.ObjectId && prevState.data.ObjectId !== this.state.data.ObjectId && !this.state.data.IsLoaded) {
      if (this.timer) clearTimeout(this.timer);
      let __this = this;
      this.timer = setTimeout(() => {
        __this.control.appendFunction({ Name: cJSonFunctionLoadPreviewData, Args: [] }, true);
      }, 500);
    }
  }

  render() {
    let content = null;
    if (!this.state.data.ObjectId) return null;

    if (this.state.data.ImageDeny === true) {
      content = getDenyImage(this.control.VCX, this.state.data.Stretch, this.control.MetaData.Bounds.Align, this.control.ComputedMinHeight);
    } else if (this.state.data.IsSupported === false) {
      content = (
        <div className="previewNotSupported">
          <div style={{ flexDirection: "column", alignSelf: "center" }}>
            <K2TruncateText line={4} style={{ textAlign: "center" }}>{`Náhled souboru "${this.state.data.ObjectId}" není podporrovaný.`}</K2TruncateText>
          </div>
        </div>
      );
    } else {
      if (this.state.data.IsLoaded) {
        if (this.isOthersSupportedFile()) {
          content = <FileViewer url={this.state.data.Alias ? this.state.data.Alias : this.state.data.ObjectId} />;
        } else {
          content = <K2Img glyphId={this.state.data.Alias ? this.state.data.Alias : this.state.data.ObjectId} vcx={this.control.VCX} />;
        }
      }
    }
    return (
      <div
        style={StyleHelper(this.control, this.props.style)}
        className={this.props.renderer.renderRule(
          (props: K2RuleWithVCXProps) => ({ backgroundColor: props.vcx.getColor(props.vcx.Data.ColorMap.DataBrowseColorBck) }),
          { vcx: this.control.VCX }
        )}
      >
        {content}
      </div>
    );
  }

  isOthersSupportedFile(): boolean {
    if (this.state.data.ObjectId) {
      let ext = this.state.data.ObjectId.substr(this.state.data.ObjectId.length - 3);
      if (ext.toUpperCase() === "PDF") {
        return true;
      }
    }
    return false;
  }
}
export const K2FilePreview = withContext(_FilePreview);

interface FileViewerProps {
  url: string;
}
interface FileViewerState {
  data: string;
  errorMessage?: string;
  url: string;
}

const urlPostfix: string = "?page=1&pagemode=none&toolbar=0&statusbar=0&navpanes=0";

class FileViewer extends React.PureComponent<FileViewerProps, FileViewerState> {
  private promise: CancelablePromise<MediaData>;

  constructor(props: FileViewerProps) {
    super(props);
    this.state = { data: null, url: null };
  }

  render() {
    let content: JSX.Element = null;
    if (this.state.url != this.props.url) {
      this.initData();
    } else {
      if (this.state.errorMessage) {
        content = (
          <K2TruncateText line={10} style={{ alignSelf: "center" }}>
            {this.state.errorMessage}
          </K2TruncateText>
        );
      } else if (this.state.data) {
        content = (
          <div style={{ width: "100%", height: "100%" }}>
            <object data={this.state.data} width={"100%"} height={"100%"}></object>
          </div>
        );
      }
    }
    return content;
  }

  private initData() {
    if (isUrl(this.props.url)) {
      this.setState({ data: this.props.url, url: this.props.url + (isPDF(this.props.url) ? urlPostfix : "") });
    } else {
      this.promise = makeCancelable<MediaData>(MediaManager.tryGetData(this.props.url));

      this.promise.promise
        .then((data) => {
          if (data.errorMessage) {
            this.setState({ errorMessage: data.errorMessage, url: this.props.url });
          } else {
            this.setState({ data: data.base64Data, url: this.props.url });
          }
        })
        .catch((reason) => {
          if (reason && !reason.isCanceled) {
            Log.error("error: " + reason, null);
          }
        });
    }
  }
}
